export default "__VITE_ASSET__DOx0BCL0__"